import React, { createContext } from 'react';

import { factoryUseContext } from '@/utils/factoryUseContext';
import { useCurrentUserAccess } from '@/store/currentUser';

interface ApplicationState {
  isAdmin: boolean;
}

const InitialState: ApplicationState = {
  isAdmin: false,
};

interface Props {
  children: JSX.Element;
}

const AdminContext = createContext(InitialState);

export const useAdminContext = factoryUseContext('Admin', AdminContext);

export function AdminContextProvider({ children }: Props): JSX.Element {
  const { isAdmin } = useCurrentUserAccess();

  return <AdminContext.Provider value={{ isAdmin }}>{children}</AdminContext.Provider>;
}
